module.exports = __webpack_public_path__ + "static/media/whocanseeclose.47a1119c.png";